import { apiCall } from "../../../services/api-service.js";

export const getalertConfigApi = async () => {
  const response = await apiCall("GET", `get_alert_list`);
  return response.data;
};
export const getalertDetailsApi = async (label) => {
  const response = await apiCall("GET", `alert_config/`);
  return response.data;
};
export const alertSubmitApi = async (data) => {
  return await apiCall("POST", `alert_config`, data);
};

//Delete
export const getDeleteFieldsApi = async (id) => {
  return await apiCall("DELETE", `alert_config/${id}`);
};

//List
export const getListApi = async (term) => {
  return await apiCall("GET", `alert_config${term}`);
};

//Gate
export const getDockListApi = async (term) => {
  return await apiCall("GET", `gatemaster/autosuggestion`);
};

//Update
export const updateConfigApi = async (id, data) => {
  return await apiCall("PUT", `alert_config/${id}`, data);
};

//Edit

export const getEditConfigApi = async (id) => {
  return await apiCall("GET", `alert_config/${id}`);
};

export const getGateListApi = async (term) => {
  return await apiCall("GET", `gate/autosuggestion?term=${term}`);
};

//Suggestionlist
export const getTypeListApi = async (term) => {
  return await apiCall("GET", `alert_config/get_list?term=${term}`);
};
